module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.bodyCss),
    attrs: {
      "id": "reportBody"
    },
    on: {
      "drop": function($event) {
        return _vm.drop($event)
      },
      "dragover": function($event) {
        return _vm.allowDrop($event)
      }
    }
  }, [_c('div', {
    style: ({
      position: 'absolute',
      width: _vm.bodyCss.width,
      height: _vm.bodyCss.height
    })
  }, [_vm._l((_vm.pageHeader.elements), function(elm, index) {
    return _c('ReportElement', {
      attrs: {
        "index": index,
        "elmData": elm,
        "maxPos": _vm.maxPos
      },
      on: {
        "removeClicked": function($event) {
          return _vm.remove(_vm.pageHeader.elements, index)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.body.elements), function(elm, index) {
    return _c('ReportElement', {
      attrs: {
        "index": index,
        "elmData": elm,
        "maxPos": _vm.maxPos
      },
      on: {
        "removeClicked": function($event) {
          return _vm.remove(_vm.body.elements, index)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36dd7978!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/ReportBody.vue
// module id = 691
// module chunks = 0